import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { formatINRShort } from "../../utils/crmDealValue";

const CrmForecastPanel = ({ forecast }) => {
  if (!forecast) return null;

  const { weightedTotal, rawTotal, byStage, winProbability } = forecast;
  const chartData = (byStage || []).filter((row) => row.weighted > 0);

  return (
    <div className="crm-forecast">
      <div className="crm-forecast__kpis">
        <div className="crm-forecast__kpi">
          <span className="crm-forecast__kpi-label">Weighted forecast</span>
          <strong>{formatINRShort(weightedTotal) || "₹0"}</strong>
          <span className="crm-forecast__kpi-sub">
            {winProbability != null ? `${winProbability}% avg win rate applied` : "Stage probabilities applied"}
          </span>
        </div>
        <div className="crm-forecast__kpi">
          <span className="crm-forecast__kpi-label">Raw pipeline</span>
          <strong>{formatINRShort(rawTotal) || "₹0"}</strong>
          <span className="crm-forecast__kpi-sub">Unweighted open deal value</span>
        </div>
      </div>

      {chartData.length > 0 && (
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 40 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="rgba(255,255,255,0.08)" />
            <XAxis
              dataKey="stage"
              angle={-25}
              textAnchor="end"
              interval={0}
              height={50}
              tick={{ fontSize: 11, fill: "rgba(238, 241, 255, 0.65)" }}
              axisLine={{ stroke: "rgba(255,255,255,0.12)" }}
              tickLine={{ stroke: "rgba(255,255,255,0.12)" }}
            />
            <YAxis
              tickFormatter={(v) => formatINRShort(v)}
              tick={{ fontSize: 10, fill: "rgba(238, 241, 255, 0.65)" }}
              width={56}
              axisLine={{ stroke: "rgba(255,255,255,0.12)" }}
              tickLine={{ stroke: "rgba(255,255,255,0.12)" }}
            />
            <Tooltip
              formatter={(v) => formatINRShort(v)}
              contentStyle={{
                background: "var(--surface-2)",
                border: "1px solid var(--border)",
                borderRadius: 10,
                color: "var(--text)",
                fontSize: 12,
              }}
              labelStyle={{ color: "var(--text-secondary)" }}
            />
            <Bar dataKey="raw" fill="rgba(34, 211, 238, 0.55)" name="Raw value" radius={[4, 4, 0, 0]} />
            <Bar dataKey="weighted" fill="#6366f1" name="Weighted forecast" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default CrmForecastPanel;
